import { ComponentPortal, ComponentType, DomPortalOutlet } from '@angular/cdk/portal';
import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, InjectionToken, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { SplitViewConf, SplitViewLayoutConf } from '../models/split-view-conf';

export const HOME_SPLIT_VIEW_SERVICE_ADAPTER: InjectionToken<any> = new InjectionToken<any>('HOME_SPLIT_VIEW_SERVICE_TOKEN');

@Injectable({
  providedIn: 'root'
})
export class SplitViewService {
  public viewConfig$: BehaviorSubject<SplitViewConf | null> = new BehaviorSubject<SplitViewConf | null>(null);
  public viewLayountConfig$: BehaviorSubject<SplitViewLayoutConf | null> = new BehaviorSubject<SplitViewLayoutConf | null>(null);

  public loadedComponent!: ComponentPortal<unknown>;
  public loadedComponentRef!: ComponentRef<unknown>;
  public bodyPortalHost!: DomPortalOutlet;
  public contextId!: string | null;

  private _portalHostElementId = 'test_portal';
  private _defaultEnableLayoutConfig: SplitViewLayoutConf = {
    isEnable: true,
    halfScreen: true,
    collapsed: false
  };

  constructor(private appRef: ApplicationRef, private componentFactoryResolver: ComponentFactoryResolver, private injector: Injector) {}

  show(component: ComponentType<any>, contextId: string, componentData: unknown = {}, splitConf: SplitViewConf) {
    this.viewConfig$.next(splitConf);
    this.viewLayountConfig$.next(this._defaultEnableLayoutConfig);

    if (contextId == this.contextId) {
      return;
    }

    this.loadedComponent = new ComponentPortal(component, null, componentData ? this._createInjector(componentData) : null);

    if (this.loadedComponentRef) {
      this.detach();
    }

    //sicuro c'è un metodo più bello per ora va bene cosi
    setTimeout(() => {
      const elementRef = document.getElementById(this._portalHostElementId) as HTMLElement;

      this.bodyPortalHost = new DomPortalOutlet(elementRef, this.componentFactoryResolver, this.appRef, this.injector);

      this.contextId = contextId;
      this.loadedComponentRef = this.bodyPortalHost.attach(this.loadedComponent);
    }, 0);
  }

  detach() {
    this.contextId = null;
    this.destroyComponentRef();
    this.detachBodyPortalHost();
  }

  layoutConfChange(conf: SplitViewLayoutConf) {
    if (!conf.isEnable) {
      this.detach();
    }

    this.viewLayountConfig$.next(conf);
  }

  confChange(conf: SplitViewConf) {
    this.viewConfig$.next(conf);
  }

  destroy() {
    this.contextId = null;
    this.destroyComponentRef();
    this.detachBodyPortalHost();

    this.viewLayountConfig$.next({
      isEnable: false,
      halfScreen: true,
      collapsed: false
    });
  }

  private _createInjector(dataToPass: unknown): Injector {
    const injector = Injector.create({
      providers: [{ provide: HOME_SPLIT_VIEW_SERVICE_ADAPTER, useValue: dataToPass }],
      parent: this.injector
    });

    return injector;
  }

  private destroyComponentRef() {
    this.loadedComponentRef && this.loadedComponentRef.destroy();
  }

  private detachBodyPortalHost() {
    this.bodyPortalHost && this.bodyPortalHost.detach();
  }
}
